import { fetchGraphQL, fetchClientGraphQL } from '~/hooks/graphql.js';

const CountryCurrencyQuery = `
  countryOptions {
    code
    name
    currencyCode
  }
`

const ActiveCountryQuery = `
  activeCountry {
    code
    name
    currencyCode
    isEuCountry
    isEuVerifyRequired
  }
`;

export interface CountryQueryResponse {
  code: string;
  name: string;
  currencyCode: string;
}

export const fetchCountriesData = (uri: string) => {
  return new Promise((resolve, reject) => {
    fetchGraphQL(`query countriesQuery { ${ CountryCurrencyQuery } }`, {}, null, false)
      .then((data) => {
        resolve(data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const fetchActiveCountryData = () => {
  return new Promise((resolve, reject) => {
    fetchClientGraphQL(`query countriesQuery { ${ ActiveCountryQuery } }`, {}, null, false)
      .then((data) => {
        resolve(data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
